import { useQuery } from '@apollo/client';

import { GetRecurringExportsDocument } from './getRecurringExports.gql';

const useGetRecurringExports = (companyProfileId = '') => {
  const { data, ...hook } = useQuery(GetRecurringExportsDocument, {
    skip: !companyProfileId,
    variables: { companyProfileId },
  });

  const recurringExportsItems =
    data?.viewer.accountingRecurringExports.edges.map(
      (accountingExportEdge) => accountingExportEdge?.node,
    ) || [];

  return { ...hook, recurringExportsItems };
};

export type RecurringExports = NonNullable<
  ReturnType<typeof useGetRecurringExports>['recurringExportsItems']
>;

export default useGetRecurringExports;

interface RefetchQueryArgs {
  companyProfileId: string;
}

export function refetchQueryGetRecurringExportsQuery({
  companyProfileId,
}: RefetchQueryArgs) {
  return {
    query: GetRecurringExportsDocument,
    variables: { companyProfileId },
  };
}
